import React from 'react';
import '../App.css'; // Ensure this file contains the shared styles

const UnitedKingdomLaw = () => {
  return (
    <div className="container">
      {/* Introduction Section */}
      <div className="introduction">
        <h1 className="introduction-title">United Kingdom Law</h1>
        <p className="introduction-text">
          The United Kingdom operates under a common law legal system where judicial decisions play a significant role 
          in the development of legal principles. It is a blend of statutory law, court precedents, and influential historical 
          documents that shape its governance and legal framework.
        </p>
      </div>

      {/* Key Features Section */}
      <div className="row">
        <div className="column">
          <h3>Common Law System</h3>
          <p>Law based on court decisions and precedents, shaping future rulings and legal interpretations.</p>
        </div>
        <div className="column">
          <h3>Magna Carta</h3>
          <p>The foundational document from 1215 establishing the principle that everyone is subject to the law.</p>
        </div>
      </div>
      <div className="row">
        <div className="column">
          <h3>Human Rights Act 1998</h3>
          <p>A law incorporating the European Convention on Human Rights into UK legislation.</p>
        </div>
        <div className="column">
          <h3>Constitutional Law</h3>
          <p>The unwritten constitution, parliamentary statutes, and common law that form the basis of governance.</p>
        </div>
      </div>
    </div>
  );
};

export default UnitedKingdomLaw;
